import React, { useEffect, useState } from "react";
import TabsList from "../../Reusable/Tabs";
import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  Popover,
  Row,
  Select,
  Table,
} from "antd";
import styled from "styled-components";
import COLORS from "../../../common/Colors";
import AccountCategory from "./Category";
import { useParams } from "react-router-dom";
import {
  SearchOutlined,
  CheckOutlined,
  DownloadOutlined,
  FormOutlined
} from "@ant-design/icons";
import EditIcon from "../../../assets/Icons/edit.svg";
import AccountStyle from "./style";
import Integration from "./Integration";
import DevelopmentImg from "../../../assets/Icons/development-img.png";

const StyledImg = styled.div`
  cursor: pointer;

  .editIcon{
    font-size: 20px;
  }
`;

const StyledTable = styled(Table)`
  padding-top: 20px;
  table {
    width: 100% !important;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    border: 1px solid #00000024;
    border-radius: 10px;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: 600;
    font-size: 0.9rem;
    color: ${COLORS.SECONDARY_BLACK};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
  .ant-table-thead > tr > th::before {
    display: none !important;
  }

  .ant-table-cell-row-hover {
    background: #e3e8fc !important;
  }
`;

const AccountSetting = () => {
  const { tab } = useParams();
  const [activeTab, setActiveTab] = useState(null);
  const [editDrawer, setEditDrawer] = useState(false);
  const [form] = Form.useForm();
  const showDrawer = () => {
    setEditDrawer(true);
  };
  const onCloseDrawer = () => {
    setEditDrawer(false);
  };
  const hanldeClickEdit = (record) => {
    console.log("record--->", record);
  };

  useEffect(() => {
    if (tab) {
      switch (tab) {
        case "portal":
          setActiveTab("1");
          break;
        case "users":
          setActiveTab("2");
          break;
        case "user-type":
          setActiveTab("3");
          break;
        case "courses":
          setActiveTab("4");
          break;
        case "categories":
          setActiveTab("5");
          break;
        case "gamification":
          setActiveTab("6");
          break;
        case "e-commerce":
          setActiveTab("7");
          break;
        case "integrations":
          setActiveTab("8");
          break;
        case "security":
          setActiveTab("9");
          break;
        case "import-export":
          setActiveTab("10");
          break;
        default:
          setActiveTab("1");
      }
    }
  }, [tab]);

  const items = [
    {
      id: "1",
      label: "Portal",
      component: <></>,
    },
    {
      id: "2",
      label: "Users",
      component: <></>,
    },
    {
      id: "3",
      label: "User types",
      component: <></>,
    },
    {
      id: "4",
      label: "Courses",
      component: <></>,
    },
    {
      id: "5",
      label: "Categories",
      component: <></>,
    },
    {
      id: "6",
      label: "Gamification",
      component: <></>,
    },
    {
      id: "7",
      label: "E-commerce",
      component: <></>,
    },
    {
      id: "8",
      label: "Integrations",
      component: <></>,
    },
    {
      id: "9",
      label: "Security",
      component: <></>,
    },
    {
      id: "10",
      label: "Import-Export",
      component: <></>,
    },
  ];

  const columns1 = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name - b.name,
    },
    {
      title: "Administrator",
      dataIndex: "administrator",
      key: "administrator",
    },
    {
      title: "Instructor",
      dataIndex: "instructor",
      key: "instructor",
    },
    {
      title: "Learner",
      dataIndex: "learner",
      key: "learner",
    },
    {
      title: "",
      dataIndex: "edit",
      key: "edit",
      width: "7%",
      render: (text, record) => {
        return (
          <StyledImg>
            <FormOutlined
              // className={hoveredRowKey === record.key ? 'download-icon show' : ''}
              className="editIcon"
              onClick={(e) => {
                e.stopPropagation();
                showDrawer();
                hanldeClickEdit(record);
              }}
            />
          </StyledImg>
        );
      },
    },
  ];

  const dataSource1 = [
    {
      key: 1,
      name: "SuperAdmin",
      administrator: true ? <CheckOutlined /> : "-",
      instructor: true ? <CheckOutlined /> : "-",
      learner: true ? <CheckOutlined /> : "-",
    },
    {
      key: 2,
      name: "Admin",
      administrator: true ? <CheckOutlined /> : "-",
      instructor: true ? <CheckOutlined /> : "-",
      learner: true ? <CheckOutlined /> : "-",
    },
    {
      key: 3,
      name: "Learner-Type",
      administrator: false ? <CheckOutlined /> : "-",
      instructor: true ? <CheckOutlined /> : "-",
      learner: true ? <CheckOutlined /> : "-",
    },
  ];

  const [userTypeFilterData, setUserTypeFilterData] = useState(dataSource1);

  const handleTabSelect = (key) => {
    setActiveTab(key);
  };

  const handleFilterData = (e) => {
    const filter = dataSource1.filter((item) => {
      if (e.target.value !== "") {
        return item.name
          .toLocaleLowerCase()
          .includes(e.target.value.toLocaleLowerCase());
      } else {
        return true;
      }
    });

    setUserTypeFilterData(filter);
  };

  return (
    <>
      <AccountStyle>
        <TabsList
          items={items}
          tabId={activeTab}
          handleTabSelect={handleTabSelect}
          activeKey={activeTab}
        />

        {activeTab === "1" && (
          <>
            <Row className="yet-designed-pages">
              <img
                src={DevelopmentImg}
                alt={DevelopmentImg}
                className="yet-designed-pages-image"
              />
              <div className="yet-designed-pages">
                <p className="developement-content">There are no Portal yet!</p>
                {/* <span className="developement-span-content">Groups allow you to assign sets of courses to several users at once.</span>
                <Button className="developement-add-button">Add group</Button> */}
              </div>
            </Row>
          </>
        )}
        {activeTab === "2" && (
          <>
            <Row className="yet-designed-pages">
              <img
                src={DevelopmentImg}
                alt={DevelopmentImg}
                className="yet-designed-pages-image"
              />
              <div className="yet-designed-pages">
                <p className="developement-content">There are no Users yet!</p>
              </div>
            </Row>
          </>
        )}

        {activeTab === "3" && (
          <>
            <Row className="users-menu-filter-container">
              <Col>
                <Form.Item name="search" className="search-input-field">
                  <Input
                    suffix={<SearchOutlined />}
                    placeholder="Search"
                    onChange={(e) => handleFilterData(e)}
                  />
                </Form.Item>
              </Col>

              <Col>
                <Button className="add-user-button">Add user type</Button>
              </Col>
            </Row>
            <StyledTable
              dataSource={userTypeFilterData}
              columns={columns1}
              rowClassName={(record, index) =>
                index % 2 === 0 ? "" : "non-white"
              }
              rowKey="key"
              id="Table"
            />

            <div className="download_csv_con">
              <Popover placement="top" content="Save as CSV">
                <DownloadOutlined />
              </Popover>
            </div>
          </>
        )}

        {activeTab === "4" && (
          <>
            <Row className="yet-designed-pages">
              <img
                src={DevelopmentImg}
                alt={DevelopmentImg}
                className="yet-designed-pages-image"
              />
              <div className="yet-designed-pages">
                <p className="developement-content">There are no Course yet!</p>
              </div>
            </Row>
          </>
        )}

        {activeTab === "5" && (
          <>
            <AccountCategory />
          </>
        )}

        {activeTab === "6" && (
          <>
            <Row className="yet-designed-pages">
              <img
                src={DevelopmentImg}
                alt={DevelopmentImg}
                className="yet-designed-pages-image"
              />
              <div className="yet-designed-pages">
                <p className="developement-content">
                  There are no Gamification yet!
                </p>
              </div>
            </Row>
          </>
        )}

        {activeTab === "7" && (
          <>
            <Row className="yet-designed-pages">
              <img
                src={DevelopmentImg}
                alt={DevelopmentImg}
                className="yet-designed-pages-image"
              />
              <div className="yet-designed-pages">
                <p className="developement-content">
                  There are no E-commerce yet!
                </p>
              </div>
            </Row>
          </>
        )}

        {activeTab === "8" && (
          <>
            <Integration />
          </>
        )}

        {activeTab === "9" && (
          <>
            <Row className="yet-designed-pages">
              <img
                src={DevelopmentImg}
                alt={DevelopmentImg}
                className="yet-designed-pages-image"
              />
              <div className="yet-designed-pages">
                <p className="developement-content">
                  There are no Security yet!
                </p>
              </div>
            </Row>
          </>
        )}

        {activeTab === "10" && (
          <>
            <Row className="yet-designed-pages">
              <img
                src={DevelopmentImg}
                alt={DevelopmentImg}
                className="yet-designed-pages-image"
              />
              <div className="yet-designed-pages">
                <p className="developement-content">
                  There are no Import-Export yet!
                </p>
              </div>
            </Row>
          </>
        )}

        <Drawer
          title="Edit user type"
          onClose={onCloseDrawer}
          open={editDrawer}
          width={600}
        >
          <Form
            layout="vertical"
            initialValues={{
              remember: true,
            }}
            form={form}
            autoComplete="off"
          >
            <Form.Item
              label="Name"
              name="userName"
              className="form_input_label"
            >
              <Input className="" />
            </Form.Item>
            <Form.Item label="User type default role" className="">
              <Select>
                <Select.Option value="demo">Demo</Select.Option>
              </Select>
              <span>
                Users can be assigned to all three roles at the same time
                (Administrator, Instructor, Learner). The default role is the
                one the system will recognize when a user logs in.
              </span>
            </Form.Item>
          </Form>
        </Drawer>
      </AccountStyle>
    </>
  );
};

export default AccountSetting;
